module.exports = __webpack_public_path__ + "img/sample-recommendations2.79f0dd16.png";